var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"close-on-click-overlay":_vm.close,"overlay-class":"a"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }